import { Card, CardBody, Col } from "reactstrap";
import { H3, P } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OverAllRatings } from "../../../../Constant";
import { OverAllRatingBox } from "./OverAllRatingBox";

const OverAllRating = () => {
const OverAllRatingData: number[] = [1, 2, 3, 4, 5];

  return (
    <Col xl="4" sm="12" md="6" className="box-col-4e">
      <Card>
        <CommonCardHeader title={OverAllRatings} className="card-no-border pb-2" />
        <CardBody className="pt-0">
          <div className="over-rating">
            <P>A credit rating is an evaluation of the credit risk of a prospective debtor predicting their ability to pay back the debt,</P>
            <div className="d-flex align-items-center">
              <div className="over-all">
                <H3>4.6</H3>
                <span className="d-block">
                  {OverAllRatingData.map((index) => (
                    <i className="fa fa-star font-warning" key={index}></i>
                  ))}
                </span>
                <P>A sovereign credit rating is the credit rating of a sovereign entity, such as a national government.</P>
              </div>
              <OverAllRatingBox />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OverAllRating;
